import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
export var white = '#FFFFFF';

if (typeof white !== 'undefined' && white && white === Object(white) && Object.isExtensible(white) && !white.hasOwnProperty('__filemeta')) {
  Object.defineProperty(white, '__filemeta', {
    configurable: true,
    value: {
      name: "white",
      filename: "node_modules/gatsby-theme-docz/src/theme/colors.js"
    }
  });
}

export var grayUltraLight = '#FCFBFA';

if (typeof grayUltraLight !== 'undefined' && grayUltraLight && grayUltraLight === Object(grayUltraLight) && Object.isExtensible(grayUltraLight) && !grayUltraLight.hasOwnProperty('__filemeta')) {
  Object.defineProperty(grayUltraLight, '__filemeta', {
    configurable: true,
    value: {
      name: "grayUltraLight",
      filename: "node_modules/gatsby-theme-docz/src/theme/colors.js"
    }
  });
}

export var grayExtraLight = '#F5F6F7';

if (typeof grayExtraLight !== 'undefined' && grayExtraLight && grayExtraLight === Object(grayExtraLight) && Object.isExtensible(grayExtraLight) && !grayExtraLight.hasOwnProperty('__filemeta')) {
  Object.defineProperty(grayExtraLight, '__filemeta', {
    configurable: true,
    value: {
      name: "grayExtraLight",
      filename: "node_modules/gatsby-theme-docz/src/theme/colors.js"
    }
  });
}

export var grayLight = '#CED4DE';

if (typeof grayLight !== 'undefined' && grayLight && grayLight === Object(grayLight) && Object.isExtensible(grayLight) && !grayLight.hasOwnProperty('__filemeta')) {
  Object.defineProperty(grayLight, '__filemeta', {
    configurable: true,
    value: {
      name: "grayLight",
      filename: "node_modules/gatsby-theme-docz/src/theme/colors.js"
    }
  });
}

export var gray = '#67788a';

if (typeof gray !== 'undefined' && gray && gray === Object(gray) && Object.isExtensible(gray) && !gray.hasOwnProperty('__filemeta')) {
  Object.defineProperty(gray, '__filemeta', {
    configurable: true,
    value: {
      name: "gray",
      filename: "node_modules/gatsby-theme-docz/src/theme/colors.js"
    }
  });
}

export var grayDark = '#2D3747';

if (typeof grayDark !== 'undefined' && grayDark && grayDark === Object(grayDark) && Object.isExtensible(grayDark) && !grayDark.hasOwnProperty('__filemeta')) {
  Object.defineProperty(grayDark, '__filemeta', {
    configurable: true,
    value: {
      name: "grayDark",
      filename: "node_modules/gatsby-theme-docz/src/theme/colors.js"
    }
  });
}

export var grayExtraDark = '#1D2330';

if (typeof grayExtraDark !== 'undefined' && grayExtraDark && grayExtraDark === Object(grayExtraDark) && Object.isExtensible(grayExtraDark) && !grayExtraDark.hasOwnProperty('__filemeta')) {
  Object.defineProperty(grayExtraDark, '__filemeta', {
    configurable: true,
    value: {
      name: "grayExtraDark",
      filename: "node_modules/gatsby-theme-docz/src/theme/colors.js"
    }
  });
}

export var dark = '#13161F';

if (typeof dark !== 'undefined' && dark && dark === Object(dark) && Object.isExtensible(dark) && !dark.hasOwnProperty('__filemeta')) {
  Object.defineProperty(dark, '__filemeta', {
    configurable: true,
    value: {
      name: "dark",
      filename: "node_modules/gatsby-theme-docz/src/theme/colors.js"
    }
  });
}

export var blueLight = '#e9f2fa';

if (typeof blueLight !== 'undefined' && blueLight && blueLight === Object(blueLight) && Object.isExtensible(blueLight) && !blueLight.hasOwnProperty('__filemeta')) {
  Object.defineProperty(blueLight, '__filemeta', {
    configurable: true,
    value: {
      name: "blueLight",
      filename: "node_modules/gatsby-theme-docz/src/theme/colors.js"
    }
  });
}

export var blue = '#0B5FFF';

if (typeof blue !== 'undefined' && blue && blue === Object(blue) && Object.isExtensible(blue) && !blue.hasOwnProperty('__filemeta')) {
  Object.defineProperty(blue, '__filemeta', {
    configurable: true,
    value: {
      name: "blue",
      filename: "node_modules/gatsby-theme-docz/src/theme/colors.js"
    }
  });
}

export var skyBlue = '#1FB6FF';

if (typeof skyBlue !== 'undefined' && skyBlue && skyBlue === Object(skyBlue) && Object.isExtensible(skyBlue) && !skyBlue.hasOwnProperty('__filemeta')) {
  Object.defineProperty(skyBlue, '__filemeta', {
    configurable: true,
    value: {
      name: "skyBlue",
      filename: "node_modules/gatsby-theme-docz/src/theme/colors.js"
    }
  });
}

export var negative = '#EB4D4B';

if (typeof negative !== 'undefined' && negative && negative === Object(negative) && Object.isExtensible(negative) && !negative.hasOwnProperty('__filemeta')) {
  Object.defineProperty(negative, '__filemeta', {
    configurable: true,
    value: {
      name: "negative",
      filename: "node_modules/gatsby-theme-docz/src/theme/colors.js"
    }
  });
}